import React, { useState, useEffect, useRef } from "react";
import { productData } from "./data/productData";
import ProductCategory from "./components/ProductCategory";
import mevedir from "./assets/images/logo.png";
import vartoh from "./assets/images/vartohlogo.avif";
import himalaya from "./assets/images/himalayblack.png";

const PopupComponent = () => {
  const [selectedCategory, setSelectedCategory] = useState("Cereals");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.classList.contains("hamburger") &&
        isSidebarOpen
      ) {
        setIsSidebarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isSidebarOpen]);

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[selectedCategory])

  const categories = Object.keys(productData);

  const handleClick = (category) => {
    setSelectedCategory(category);
    setIsSidebarOpen(false);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="popup-content">
      <div className="header-space">
        <button className="hamburger" onClick={toggleSidebar}>
          <i className="fas fa-bars"></i>
        </button>
        <img src={mevedir} alt="mevedir logo" className="header-logo" />
      </div>

      <div ref={sidebarRef} className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <img src={mevedir} alt="mevedir products-logo" className="logo mob-logo" />
        <ul>
          {categories.map((category) => (
            <li
              key={category}
              className={selectedCategory === category ? "selected" : ""}
              onClick={() => handleClick(category)}
            >
              {category}
            </li>
          ))}
        </ul>
        <div className="stores">
          <div className="stores-logos">
            <a href="https://www.vartohorganic.com/" target="_blank" rel="noopener noreferrer">
              <img src={vartoh} alt="vartoh organic logo" className="voimg" />
            </a>
            <a href="https://www.himalayfrsh.com/" target="_blank" rel="noopener noreferrer">
              <img src={himalaya} alt="himalay frsh logo" className="himg" />
            </a>
          </div>
        </div>
        <div className="backbtn" onClick={() => (window.location.href = "/")}>
          <i className="fas fa-arrow-left"></i>
          <span>Go to Homepage</span>
        </div>
      </div>

      <div className="content-area">
        <ProductCategory key={selectedCategory} category={productData[selectedCategory]} />
      </div>
      <a href="https://wa.me/919883965595" className="whatsapp-float" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp"><i className="fa-brands fa-whatsapp"></i></a>
    </div>
  );
};

export default PopupComponent;
